<template>
    <div class="pcr-establishment">
        <el-tabs type="border-card" @tab-click="tabClick" :value="$store.state.activeTab['establishment']">
            <el-tab-pane label="Informations" name="Informations" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.blind">
                <establishment-informations :establishment-id="establishmentId"></establishment-informations>
            </el-tab-pane>
            <el-tab-pane label="Groupes" name="Groupes" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.viewer">
                <establishment-group-list :establishment-id="establishmentId"></establishment-group-list>
            </el-tab-pane>
            <el-tab-pane label="Utilisateurs" name="Utilisateurs" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.viewer">
                <establishment-user-list :node-id="establishmentId"></establishment-user-list>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('establishment-index', {
    props: {
        establishmentId: {
            default: function() {
                return 0;
            }
        }
    },
    data() {
        return {
        }
    },
    mounted: function() {
    },
    methods: {
        tabClick(tab) {
            this.$store.commit('setActiveTab', { type: "establishment", name: tab.name } );
        }
    },
    watch: {
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/establishment/establishment-index.vue